import http from "../http-common";
/* eslint-disable */
class PsikologisKategorisService {
  getListAll(type) {
    return http.get("/psikologis-kategoris/list/all?alat_test_id=" + type, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new PsikologisKategorisService();
